import React from 'react';

import styled from 'styled-components';



const RichText = ({ block, ...props }) => {

  return (
    <Container
      dangerouslySetInnerHTML={ {__html: block.body} }
      {...props}
    />
  )
};


export default RichText;

const Container = styled.section`
  max-width: ${({ theme }) => theme.content.CONTENT_WIDTH};
  width: 90%;
  p {
    font-size: 2em;
    line-height: 1.5;
    color: ${({ theme }) => theme.colors.Primary};
    &:not(:first-of-type) {
      margin-top: 1em;
    }
    strong {
      font-weight: 700;
    }
    em {
      font-style: italic;
    }
  }
  li {
    color: ${({ theme }) => theme.colors.Primary};
    font-family: 'Averia Serif Libre', serif;
    font-size: inherit;
    li {
      font-size: inherit;
    }
  }
  ul {
    list-style: initial;
    ul {
      list-style-type: circle;
    }
  }
  ol {
    list-style: decimal;
    ol {
      list-style-type: lower-roman;
    }
  }
  ol,ul {
    padding-left: 10%;
    margin: 1em 0;
    ul,ol {
      padding-left: 5%;
      margin: 0.5em 0;
    }
  }
`;
